module.exports = __webpack_public_path__ + "img/icon_sekilas.e1d76a25.svg";